import React from "react";
import Image from "next/image";
import { IoMdShareAlt } from "react-icons/io";
import styles from "./CommonHeader.module.css";
import { withRegionPath } from "@/utils/session";

// Placeholder for images/icons
const calendarIcon = "/images/icons/Calender.svg";
const clockIcon = "/images/icons/Clock.svg";
const writerIcon = "/images/icons/Author.svg";

export default function CommonHeader({
  title,
  subtitle,
  date,
  readTime,
  author,
  authorSlug,
  buttonText,
  buttonLink = "",
  bgImage,
  onButtonClick,
  onShareClick,
  isBlogPage = false,
  className = "",
  classNameHead = ""
}) {
  const authorHref = withRegionPath(`/blog/author/${authorSlug}`);
  const heroAlt =
    typeof title === "string" && title.trim()
      ? title.trim()
      : "Page banner";

  const hasOverlayContent =
    Boolean(title || buttonText) ||
    (isBlogPage &&
      Boolean(subtitle || date || readTime || author || onShareClick));

  return (
    <header
      className={`${styles.commonHeader} ${className}`.trim()}
    >
      {bgImage ? (
        <Image
          src={bgImage}
          alt={heroAlt}
          width={1920}
          height={480}
          priority
          quality={70}
          sizes="100vw"
          className={`standard-heroimg ${styles.commonHeaderHero} ${classNameHead}`}
        />
      ) : null}
      {hasOverlayContent ? (
        <div
          className={`${styles.commonHeaderOverlay} ${isBlogPage ? styles.blogHeaderOverlay : ""
            }`}
        >
          <div className={`standard-padding ${styles.commonHeaderContainer}`}>
            <div
              className={`${styles.commonHeaderContent} ${isBlogPage ? styles.blogHeaderContent : ""
                }`}
            >
              {title && (
                <h1
                  className={`${styles.commonHeaderTitle} ${isBlogPage ? styles.blogHeaderTitle : ""
                    }`}
                >
                  {title}
                </h1>
              )}

              {/* Blog specific details */}
              {isBlogPage && subtitle && (
                <p className={styles.blogSubtitle}>{subtitle}</p>
              )}

              {isBlogPage && (date || readTime || author) && (
                <div className={styles.blogMeta}>
                  {date && (
                    <span className={styles.blogMetaItem}>
                      <img
                        src={calendarIcon}
                        alt="Calendar"
                        className={styles.metaIcon}
                      />
                      {date}
                    </span>
                  )}
                  {readTime && (
                    <span className={styles.blogMetaItem}>
                      <img
                        src={clockIcon}
                        alt="Clock"
                        className={styles.metaIcon}
                      />
                      {readTime}
                    </span>
                  )}
                  {author && authorHref ? (
                    <a href={authorHref} className={styles.blogMetaItemLink}>
                      <span className={styles.blogMetaItem}>
                        <img
                          src={writerIcon}
                          alt="Writer"
                          className={styles.metaIcon}
                        />
                        Author: {author}
                      </span>
                    </a>
                  ) : null}
                  {author && !authorHref ? (
                    <span className={styles.blogMetaItem}>
                      <img
                        src={writerIcon}
                        alt="Writer"
                        className={styles.metaIcon}
                      />
                      Author: {author}
                    </span>
                  ) : null}
                  {onShareClick ? (
                    <button
                      type="button"
                      className={`${styles.blogMetaItem} ${styles.blogMetaShare} ${styles.blogMetaShareBtn}`}
                      aria-label="Share article"
                      onClick={onShareClick}
                    >
                      <IoMdShareAlt className={styles.metaIconReact} />
                    </button>
                  ) : (
                    <span
                      className={`${styles.blogMetaItem} ${styles.blogMetaShare}`}
                    >
                      <IoMdShareAlt className={styles.metaIconReact} />
                    </span>
                  )}
                </div>
              )}

              {buttonText && (
                <div className={styles.commonHeaderBtnWrap}>
                  {buttonLink ? (
                    <a
                      href={buttonLink}
                      className={styles.commonHeaderBtn}
                      onClick={onButtonClick}
                    >
                      {buttonText}
                    </a>
                  ) : (
                    <button
                      type="button"
                      className={styles.commonHeaderBtn}
                      onClick={onButtonClick}
                    >
                      {buttonText}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </header>
  );
}